/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import "../css/about.css";
import MediaQuery from "react-responsive";

function About() {
    const [rotate, setRotate] = useState(1);

    function rotateSquare() {
        let angle = rotate * 90;

        const facts = document.getElementsByClassName("fact");
        facts[(rotate-1)%4].classList.remove("fw-bold");
        facts[rotate%4].classList.add("fw-bold");

        setRotate(rotate + 1);

        document.getElementById("about-square").style.transform = "rotate(" + angle + "deg)";
    }
    return (
    <section id="about" className="container-fluid">
        <div className="row fill-height align-items-center">
            <div className="col-1"></div>
            <div className="col-10 text-center reveal">
                <h1 className="display-2 marginbtm">About</h1>
                <MediaQuery maxWidth={"992px"}>
                    <p className="h5 fw-lighter marginbtm">
                        As a 3D Generalist with a focus in modeling and texturing, I utilize the entire industry pipeline to create assets and render my scenes. 
                        I love bringing my ideas to life and enjoy the creative process of doing so.
                    </p>
                    <ul id="about-list" className="h2 fw-lighter marginbtm">
                        <li>3D artist and developer born in Calgary, Alberta, Canada</li>
                        <li>UBCO and VCAD graduate in Computer Science and Game Development & Design</li>
                        <li>Well versed in industry-standard tools and many programming languages</li>
                        <li>Strong understanding and knowledge of professional pipelines and workflows</li>
                    </ul>
                </MediaQuery>
                <MediaQuery minWidth={"993px"}>
                    <div id="about-square" className="center ease-1s" style = {{transform : "rotate(0deg)"}}>
                        <p className="fact h2 fw-lighter fw-bold">3D artist and developer born in Calgary, Alberta, Canada</p>
                        <p className="fact h2 fw-lighter">UBCO and VCAD graduate in Computer Science and Game Development & Design</p>
                        <p className="fact h2 fw-lighter">Well versed in industry-standard tools and many programming languages</p>
                        <p className="fact h2 fw-lighter">Strong understanding and knowledge of professional pipelines and workflows</p>
                    </div>
                    <p>
                        <svg id="rotator" onClick={rotateSquare} xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-arrow-clockwise marginbtm" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                        </svg>
                    </p>
                <p className="h5 mx-auto fw-lighter marginbtm" style={{width : "30rem"}}>
                    As a 3D Generalist with a focus in modeling and texturing, I utilize the entire industry pipeline to create assets and render my scenes. 
                    I love bringing my ideas to life and enjoy the creative process of doing so.
                </p>
                </MediaQuery>
                <a href="#experience" className="text-decoration-none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-chevron-double-down mb-4" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                        <path fillRule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg><br/>
                    <span className="text-black">Experience</span>
                </a>
            </div>
            <div className="col-1"></div>
        </div>
    </section>
    );
}

export default About;